/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Intro_Compliance_Chip2_AnswerInputs */



/**
* | output |
* | --- |
* | "It uses an LLM to rate content risk from minimal to unacceptable with configurable actions, catching issues that fixed patterns miss. It requires the Complia..." |
*
* @param {Uno_Edu_Intro_Compliance_Chip2_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_intro_compliance_chip2_answer = /** @type {((inputs?: Uno_Edu_Intro_Compliance_Chip2_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Intro_Compliance_Chip2_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie bewertet mit einem LLM das Inhaltsrisiko von minimal bis inakzeptabel mit konfigurierbaren Aktionen und erkennt Probleme, die feste Muster übersehen. Sie erfordert das Add-on Compliance Copilot.")
	return /** @type {LocalizedString} */ ("It uses an LLM to rate content risk from minimal to unacceptable with configurable actions, catching issues that fixed patterns miss. It requires the Compliance Copilot add-on.")
});